module.exports = __webpack_public_path__ + "static/motoriseeritud-2bc96417effdcf8f01bda933265fb46c.png";